import { CreateEvent } from "../../redux/features/event/event.types";
import { Icon } from "../icon/icon";

type NoticeProps = Partial<
  Pick<CreateEvent, "location" | "placeholderLocation" | "type" | "tickets">
> & { currency?: string };

export const CanadianAlcoholNotice = ({
  currency,
  location,
  placeholderLocation,
  type,
  tickets,
}: NoticeProps) => {
  const isCAD = (value?: string) =>
    ["cad", "canadian dollars"].includes(value?.trim().toLowerCase() ?? "");
  const country = (placeholderLocation || location)
    ?.split(",")
    .pop()
    ?.trim()
    .toLowerCase();
  const isCanadian =
    isCAD(currency) ||
    tickets?.some((ticket) => isCAD(ticket.currency)) ||
    (type !== "virtual" && (country === "canada" || country === "ca"));

  if (!isCanadian) return null;

  return (
    <aside
      aria-label="Alcohol and ticket sales"
      className="col-span-full flex w-full items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 p-4 text-sm text-grey-950"
    >
      <span aria-hidden="true" className="shrink-0 text-amber-800">
        <Icon svg="info" width={20} height={20} />
      </span>
      <div className="min-w-0">
        <p className="font-bold">Alcohol and ticket sales</p>
        <p className="mt-1">
          Alcohol must not be included in the ticket price.
          Alcohol may still be offered or sold separately at the event by a
          properly licensed organizer, venue or vendor.
        </p>
      </div>
    </aside>
  );
};
